const classifyWord = (singular, plural, whereSingular) =>
  whereSingular ? singular : plural;

export default classifyWord;
